export const TRANSACTION_DIRECTION = {
  DEBIT: 'debit',
  CREDIT: 'credit'
};

export const MONEY_COLOR = {
  PRIMARY: 'primary',
  GREEN: 'green',
  TERTIARY: 'tertiary'
};
